<template>
  <div id="home" class="home">
    <div class="header">
      <img class="bg-img" src="https://iogw.cgo.ink:9000/hgzpub/pic/ydhgg/mipmap-xxhdpi/bg.webp" />
      <div class="time">
        <div class="title">距离运动会开幕还有</div>
        <div class="content">{{ dayNum }}<span>天</span> {{ hourNum }}<span>时</span> {{ minuteNum }}<span>分</span> {{ secondNum }}<span>秒</span></div>
      </div>
    </div>
    <div class="content-box">
      <van-tabs @click="onClick" v-model="active" swipeable background="#F5F6F8" sticky>
        <van-tab v-for="(item1, index1) in tabsList" :key="index1" :title="item1.title" :name="item1.active">
          <div v-if="item1.active==='Announcement'" class="card-box">
            <itemList :dataInfo="announcementInfo"></itemList>
          </div>
          <div v-if="item1.active==='Information'" class="card-box">
            <itemList :dataInfo="informationInfo"></itemList>
          </div>
          <div v-if="item1.active==='Introduction'" class="card-box">
            <div class="card-box">
              <div class="content" v-html="introductionInfo"></div>
            </div>
            <div class="card-box">
              <img style=" width: 100% !important;" src="@/assets/news/introduction1.webp" />
              <img style=" width: 100% !important;" src="@/assets/news/introduction2.webp" />
            </div>
          </div>
          <div v-if="item1.active==='Guide'" class="card-box">
            <div class="card-box">
              <div class="content" v-html="guideInfo"></div>
            </div>
          </div>
          <div v-if="item1.active==='File'" class="card-box">
            <itemList :dataInfo="fileInfo"></itemList>
          </div>
          <div v-if="item1.active==='Partner'" class="card-box">
            <div class="card-box">
              <div class="content" v-html="partnerInfo.title"></div>
              <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/hzhpslices/bitmap5@2x.webp" />
              <div class="content" v-html="partnerInfo.content"></div>
            </div>
          </div>
          <div v-if="item1.active==='Org'" class="card-box">
            <div class="card-box">
              <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/zwhslices/1@2x.webp" />
            </div>
          </div>
          <div v-if="item1.active==='Contact'" class="card-box">
            <div class="card-box">
              <div class="content" v-html="contactInfo"></div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import itemList from '@/components/common/itemList.vue'
export default {
    created() {
        this.init()
    },
    mounted() {
        this.timer = setInterval(this.updateCountdown, 1000) // 每秒更新一次倒计时
    },
    data() {
        return {
            endDate: new Date('2025-08-15T19:00:00').getTime(), // 目标日期时间戳
            timer: null, // 定时器变量
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            tabsList: [
            { active: 'Announcement', title: '赛事公告' },
            { active: 'Information', title: '赛事资讯' },
            { active: 'Introduction', title: '赛事介绍' },
            { active: 'Guide', title: '赛事指南' },
            { active: 'File', title: '官方文件' },
            { active: 'Partner', title: '合作伙伴' },
            { active: 'Org', title: '赛事组委会' },
            { active: 'Contact', title: '联系我们' }
            ],
            active: 'Announcement',
            announcementInfo: [
                {
                    label: '赛事公告',
                    title: '2025世界人形机器人运动会面向全球公开征集赛事口号',
                    time: '2025-05-25',
                    content: `<p class="p" style="text-indent:28pt;">
	2025世界人形机器人运动会（以下简称"机器人运动会"）将于8月15日在中国北京举行。本届运动会致力于推动机器人产业蓬勃发展与技术迭代升级，让机器人更快更好地走进人类生活，服务经济社会进步，促进科技、体育、文化深度融合，构建一个集科技竞技、经济促进、国际交流于一体的科技体育盛会。
</p>
<p class="p" style="text-indent:28pt;">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 从发布之日起，赛事组委会面向全球征集赛事口号，征集截止日期为6月20日，衷心欢迎海内外所有关心和支持机器人运动会的自然人、法人和其他组织（以下统称"应征人"）踊跃参与到活动中来，为机器人运动会贡献才智，共铸辉煌。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	一、应征人
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 应征人完全理解并接受征集条件和要求，愿意为机器人运动会提供口号或可作为口号的创作方向、灵感和参考。赛事组委会将从中优选出符合赛事特点和要求的口号。赛事组委会有权决定创作团队及其创意组成，可以使用所有应征口号形成最终的口号。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	二、相关要求
</p>
<p class="p">
	（一）主题鲜明
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 口号需紧密围绕"世界人形机器人运动会"这一主题，突出国际化、科技感和竞技精神，体现人形机器人运动的创新性，传递科技赋能、人机共融等前沿理念，以积极正向的运动精神激发共鸣，内容避免生僻字、歧义或负面含义，符合社会公序良俗。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	(二）创意独特
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 口号应独具创意，能够迅速吸引公众的关注，能在人们心中留下深刻印象。鼓励参赛者打破常规，运用巧妙的语言艺术和独特的视角，创作出令人耳目一新的口号。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	(三）简洁明了
</p>
<p class="p">
	&emsp; &nbsp; &nbsp; &emsp;<span>口号应简洁有力，朗朗上口。字数尽量控制在</span><span>10字以内，精准传达出运动会的精神内涵和核心价值。避免使用冗长或复杂的句子结构，口号应便于记忆和传播。</span>
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	(四）积极向上
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 口号需传递积极向上的正能量，营造充满活力和希望的赛事氛围，表达对科技发展的信心和对未来美好生活的向往，成为激励人心的精神旗帜。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	三、征集内容
</p>
<p class="p">
	&emsp;1.口号作品中文版和英文版。
</p>
<p class="p">
	&emsp;2.创意说明（自主选择提交，50字左右）。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	四、提交方式
</p>
<p class="p">
	&emsp;(一）电子邮件
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 邮件标题：应征人名称+2025世界人形机器人运动会口号，邮件内容：2025世界人形机器人运动会口号+应征人承诺函（详见赛事官网https://www.whrgoc.com），邮件地址：2025whrg@whrgoc.com。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp;(二）微信小程序
</p>
<p class="p">
	&nbsp; &nbsp;&nbsp; &nbsp; &nbsp; 搜索官方指定微信小程序"红果子"，在口号征集 专区提交。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	五、评审方式
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 赛事口号由2025世界人形机器人运动会组委会评审，其中，评选前10名为入围作品，评选第1名为中选作品。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	六、奖励办法
</p>
<p class="p">
	(一）入围作品
</p>
<p class="p">
	&nbsp; &nbsp;<span>向入围作品的应征人颁发证书、奖金</span><span>1000元。</span>
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	(二）中选作品
</p>
<p class="p">
	&nbsp; &nbsp;<span>向中选作品的应征人颁发证书、奖金</span><span>10000元。</span>
</p>
<p class="p">
	&nbsp; &nbsp;注：奖金不可兼得。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	七、其他未尽事宜
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 应征人可通过2025世界人形机器人运动会官方网站的赛事公告板块
</p>
<p class="18">
	(https://www.whrgoc.com）了解、关注、下载征集工作相关信息和动态。
</p>
<p class="p">
	&nbsp;
</p>
<p class="19" style="text-align:right;">
	世界人形机器人运动会组委会
</p>
<p class="19" style="text-align:right;">
	2025年5月
</p>`
                },
                {
                  label: '赛事公告',
                    title: '2025世界人形机器人运动会赛事介绍',
                    time: '2025-05-07',
                    content: `
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp;2025世界人形机器人运动会将于2025年8月15日-17日在国家体育场（鸟巢）和国家速滑馆（冰丝带）举办。本届赛事由北京市人民政府、中央广播电视总台、世界机器人合作组织、亚太机器人世界杯国际理事会联合主办，作为全球首届以运动会形式展示人形机器人竞技的高水平舞台，欢迎全球范围机器人企业、机器人俱乐部及高等院校前来一展风采。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp;本届赛事聚焦人形机器人发展的阶段性成果，立足实际场景应用，设置竞技赛、表演赛和场景赛三类项目。竞技赛包括100米、400米、1500米、4×100米等田径赛事、自由体操、足球等项目；表演赛包括单机舞蹈和群体舞蹈；场景赛包括物料搬运、分拣和整理、清洁服务等项目。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp;本届赛事将与RoboCup亚太理事会深度合作，打造全新潮流赛事品牌“亚太机器人世界杯北京大师赛”，呈现精彩纷呈的机器人足球赛事。通过搭建竞技展示平台，推动机器人更快更好地走进人类生活，服务经济社会进步，促进科技、体育、文化深度融合，构建一个集科技竞技、经济促进、国际交流于一体的国际盛会平台，打造开放、合作、和谐共享的世界级人形机器人科技体育赛事。
</p>
<p class="MsoNormal">
	<b>&nbsp;</b> 
</p>
<p class="p">
	<strong>赛事名称</strong> 
</p>
<p class="p">
	2025世界人形机器人运动会（简称"机器人运动会"），英文名"2025 World Humanoid Robot Games"（WHRG）
</p>
<p class="p">
	<strong>赛事时间</strong> 
</p>
<p class="p">
	2025年8月15日至8月17日（周五至周日）
</p>
<p class="p">
	<strong>赛事地点</strong> 
</p>
<p class="p">
	国家速滑馆（冰丝带）、国家体育场（鸟巢）
</p>
<p class="p">
	<strong>参赛对象</strong> 
</p>
<p class="p">
	全球范围内的机器人企业、机器人俱乐部、高等院校等
</p>
<p class="p">
	<strong>主办单位</strong> 
</p>
<p class="p">
	北京市人民政府、中央广播电视总台、世界机器人合作组织、亚太机器人世界杯国际理事会
</p>
<p class="p">
	<strong>承办单位</strong> 
</p>
<p class="p">
	北京市经济和信息化局、北京市体育局、中央广播电视总台北京总站、北京广播电视台、北京市朝阳区人民政府、北京市教育委员会、中国电子信息产业发展研究院、中国电子学会、北京市国有资产经营有限责任公司、首钢集团有限公司
</p>
<p class="p">
	<strong>协办单位</strong> 
</p>
<p class="p">
	全国大学生机器人大赛组委会、北京市机器人产业协会
</p>
<p class="p">
	<strong>执行单位</strong> 
</p>
<p class="p">
	北京北奥集团有限责任公司、北京首钢基金有限公司
</p>
<p>
	<br />
</p>
<p class="19" style="text-align:right;">
	<br />
</p>`
                }
            ],
            informationInfo: [
                {
                  label: '赛事资讯',
                    title: '全球首个人形机器人运动会—8月北京鸟巢+冰丝带见！',
                    time: '2025-05-13',
                    content: `
	<p class="p">
		&nbsp; &nbsp; &nbsp; &nbsp;2025世界人形机器人运动会，将于今年8月15日至17日在国家体育场（鸟巢）和国家速滑馆（冰丝带）举办，北奥集团负责赛事运营。
	</p>
	<p class="p">
		<br />
	</p>
     <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail1/1@2x.webp" />
<p class="p">
	首批比赛项目揭秘
</p>
<img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail1/2@2x.webp" />
	<p class="p">
		2025年世界人形机器人运动会的第一批比赛项目分为主体赛事和外围赛事。
	</p>
	<p class="p">
		&nbsp;其中，主体赛事包括竞技赛、表演赛和场景赛，共计三类、19个项目。
	</p>
    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail1/3@2x.webp" />
<p class="p">
	· 竞技赛参照人类传统体育项目，设置了11个赛项。具体包括田径7项：100米、400米、1500米、4×100米接力、100米障碍赛和立定跳远、原地跳高；还有自由体操和2v2、3v3、5v5足球赛。这些项目将重点考验机器人的运动能力、协调性与团队协作能力。
</p>
<p class="p">
	· 表演赛设置了单机舞蹈、群体舞蹈2个项目，通过艺术编排、音乐配合与动作创新，展示人形机器人全身实时协同控制和群体协同能力。
</p>
<p class="p">
	· 场景赛聚焦人形机器人实际应用场景，设置了工业场景、医院场景和酒店场景共三类、6个项目，展示机器人的实用技能和智能化水平。
</p>
<p class="p">
	&nbsp; 外围赛事安排了3个项目，包括非人形机器人羽毛球、篮球和乒乓球。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 本届运动会的比赛项目和竞赛规则主要有三个方面的考虑——
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	· 一是适度参考人类体育竞赛项目，展现现阶段机器人技术发展水平。通过模仿人类运动形式，推动机器人机械结构优化、运动算法升级。
</p>
<p class="p">
	· 二是紧密结合人类生产生活，探索机器人实用化场景。场景赛是本届赛事的一大亮点，三个项目都来源于真实场景，为机器人的商业化应用提供了实践案例。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 比如，工厂场景中，物料搬运技能项目，设定为在规定时间内，机器人将进气门物料箱和排气门物料箱，从线边料车搬运并分别摆放到智能料架上。物料整理技能项目，设定为在规定时间内，机器人将一个物料箱中的进气门物料，尽可能多地整理放入另一个物料箱中。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&emsp; &nbsp; &nbsp; &emsp;医院场景中，药品分拣技能项目，设定为在规定时间内，机器人依据处方要求，从药品架取药并放置在工作台上。拆药分装技能项目，设定为在规定时间内，机器人将板装胶囊药品中的胶囊拆装，并放入药品分装盒中。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&emsp; &nbsp; &nbsp; &emsp;酒店场景中，迎宾服务技能项目，设定为在规定时间内，机器人将酒店门厅入口位置的拉杆箱，通过行李输送车送到各区域，再摆放到房间门口。清洁服务技能项目，设定为在规定时间内，机器人推门进入酒店客房，将客房内的矿泉水空瓶、纸团、一次性食品盒等垃圾放入垃圾桶，关门离开。
</p>
<p class="p">
    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail1/4.webp" />
	&nbsp;除以上三个场景外，组委会还在研究论证其他应用场景，特别是不适合人类从事的工作场景，后续将陆续发布。
</p>
<p class="p">
	&nbsp;
</p>
<p class="MsoNormal">
	· 三是外围赛事为机器人提供表演展示舞台，通过非人形机器人羽毛球、篮球、乒乓球比赛，展示机器人的各种性能，同时还可以安排人机互动体验。
</p>
<p>
	<br />
</p>
<p class="19" style="text-align:right;">
	<br />
</p>`
                },
                {
                  label: '赛事资讯',
                    title: '2025世界人形机器人运动会竞赛规则新鲜出炉',
                    time: '2025-05-08',
                    content: `<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp;2025世界人形机器人运动会将于8月15-17日在国家体育场（鸟巢）和国家速滑馆（冰丝带）举办。赛事由北京市人民政府、中央广播电视总台、世界机器人合作组织、亚太机器人世界杯国际理事会联合主办，北奥集团负责赛事运营。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 赛事组委会已正式公布运动会第一批赛项设置及竞赛规则，即日起，可前往2025世界人形机器人运动会官方网站(https://www.whrgoc.com），在“官方文件”版块下载《世界人形机器人运动会比赛规则（第一批）》。
</p>

    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail3/1@2x.webp" />
<p class="p">
	<span>本届运动会竞赛项目规划为</span><span>“主体赛事+外围赛事”。首批主体赛事包含竞技赛、表演赛、场景赛3类19个赛项。</span> 
</p>
<p class="p">
	&nbsp; &nbsp;<span>竞技赛：设置</span><span>11个赛项，包括100米、400米、1500米、4×100米接力、100米障碍、立定跳远、原地跳高、自由体操、足球2v2、足球3v3、足球5v5。着重考察人形机器人的高速运动稳定性、复杂环境适应性、爆发力与精准控制、多机协同等能力。</span> 
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 表演赛：设置2个赛项，包括单机舞蹈、群体舞蹈。着重考察人形机器人的全身实时协同控制和群体协同等能力。
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 场景赛：设置6个赛项，包括工厂场景-物料搬运技能竞技、工厂场景-物料整理技能竞技、医院场景-药品分拣技能竞技、医院场景-拆药分装技能竞技、酒店场景-迎宾服务技能竞技、酒店场景-清洁服务技能竞技。着重考察人形机器人在场景应用中的精细作业能力、智能化水平等。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; &nbsp; 外围赛事包含羽毛球、篮球、乒乓球3个小项，侧重表演及与观众互动。
</p>

    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail3/3@2x.webp" />
    
    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail3/4@2x.webp" />`
                },
                {
                  label: '赛事资讯',
                    title: '倒计时100天！2025世界人形机器人运动会在京正式启动',
                    time: '2025-05-07',
                    content: `<p class="p">
	<p class="p" style="text-indent:28pt;">
		5月7日，北京市人民政府新闻办公室举行2025世界人形机器人运动会新闻发布会，市经济和信息化局党组书记、局长姜广智，中国电子学会副理事长兼秘书长、总部党委书记陈英，市体育局二级巡视员张华，北京经济技术开发区工委委员、管委会副主任王磊，朝阳区委常委、副区长舒毕磊出席发布会，介绍相关情况并回答媒体提问。
	</p>
    <img width="100%" src="https://iogw.cgo.ink:9000/hgzpub/pic/sszxdetail3a/1@2x.webp"
	<p class="p" style="text-indent:28pt;">
		<span>发布会上，市经济和信息化局党组书记、局长姜广智介绍了运动会整体情况。本届运动会将于</span>8月15-17日在国家体育场（鸟巢）和国家速滑馆（冰丝带）举办。赛事由北京市人民政府、中央广播电视总台、世界机器人合作组织、亚太机器人世界杯国际理事会联合主办，北京市经济和信息化局、北京市体育局、中央广播电视总台北京总站、北京广播电视台、北京市朝阳区人民政府、北京市教育委员会、中国电子信息产业发展研究院、中国电子学会、北京市国有资产经营有限责任公司、首钢集团有限公司联合承办，执行单位为北奥集团、首钢基金。作为全球首个为人形机器人举办的综合性赛事，将致力于推动具身智能机器人的科技创新发展，探索建立人形机器人的全领域性能评估标准，引领机器人产业的高质量发展，为北京国际交往中心建设、科技创新中心建设、国际消费中心城市建设和全球数字经济标杆城市建设提供新动力。
	</p>
	<p class="p" style="text-indent:28pt;">
		<span>市体育局二级巡视员张华介绍了运动会赛事赛项有关情况。竞赛项目设置整体规划为</span><span>"主体赛事+外围赛事"，主体赛事包括竞技赛、表演赛和场景赛三类19个项目，包含田径、足球、体操、舞蹈、工业场景等；外围赛事包含羽毛球、篮球、乒乓球3个小项，侧重表演及与观众互动。以上项目为第一轮赛项，后续视情况将发布更多赛项。本届运动会将面向全球机器人企业、创新团队、机器人俱乐部、高等院校、科研机构以及机器人爱好者开放参赛邀请。</span>
	</p>
	<p class="p" style="text-indent:24pt;">
		&nbsp;
	</p>
	<p class="p" style="text-indent:28pt;">
		<span>朝阳区委常委、副区长舒毕磊介绍运动会服务保障情况。在国家体育场、国家速滑馆和奥林匹克中心区内，做好环境美化、交通优化，协调周边餐饮酒店，预留客房和用餐席位，做好车辆停放、公共交通出行引导等，为运动会举办提供人性化、专业化的服务保障体系，满足参赛团队、游客观众的</span><span>"吃住行游购娱"多样化消费需求。定期组织专业力量对场馆搭建及周边生产经营单位的安全生产进行检查监督，营造安全和谐的办赛环境。舒毕磊同志还代表组委会正式启动赛事口号征集活动。即日起至6月30日，社会各界可通过赛事官方网站</span><span>（</span><span>https://www.whrgoc.com）或邮箱2025whrg@whrgoc.com</span>提交创意方案。
	</p>
	<p class="p" style="text-indent:24pt;">
		&nbsp;
	</p>
	<p class="p" style="text-indent:28pt;">
		<span>此次新闻发布会的成功举办，标志着</span><span>2025世界人形机器人运动会正式拉开帷幕，为赛事的顺利举办奠定了良好的基础。届时，来自全球的机器人团队、行业专家及机器人爱好者将齐聚一堂，共同见证科技与体育竞技融合的精彩盛宴。</span>
	</p>
</p>
<p class="p">
	<br />
</p>`
                }
            ],
            introductionInfo: `<p class="p" style="text-indent:28pt;">
	2025世界人形机器人运动会设置竞技赛、表演赛、场景赛3类比赛项目。根据运动会实际开展情况，2025世界人形机器人运动会组委会（以下简称"组委会"）将动态调整赛项设置，并保留增设相关赛项的权利。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	<span></span><span></span><span></span><span><strong>1.竞技</strong><strong>赛</strong><strong>：</strong>设置11个赛项，包括100米、400米、1500米、4×100米接力、100米障碍、立定跳远、原地跳高、自由体操、足球2v2、足球3v3、足球5v5。着重考察人形机器人的高速运动稳定性、复杂环境适应性、爆发力与精准控制、多机协同等能力。</span> 
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	<strong>2.表演赛：</strong>设置2个赛项，包括单机舞蹈、群体舞蹈。着重考察人形机器人的全身实时协同控制和群体协同等能力。
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	<strong>3.场景赛：</strong>设置6个赛项，包括工厂场景-物料搬运技能竞技、工厂场景-物料整理技能竞技、医院场景-药品分拣技能竞技、医院场景-拆药分装技能竞技、酒店场景-清洁服务技能竞技、酒店场景-迎宾服务技能竞技。着重考察人形机器人在场景应用中的精细作业能力、智能化水平等。
</p>`,
            guideInfo: `
	<div align="center" style="margin-left:0.0000pt;text-align:center;margin-bottom:10px">
		<div style="color:#334694;font-size:24px;font-weight:500">参赛要求</div>
	</div>
	<p class="p"  style="text-indent:28pt;">
		1. 国内外企业、高校、科研院所、创新团队、俱乐部、其他社会组织等均可报名。
	</p>
	<p class="p" style="text-indent:28pt;">
		2. 报名条件详见官网比赛规则。
	</p>
	<p class="p" style="text-indent:28pt;">
		3. 8月15日在国家体育场（鸟巢）举办全部田径赛事。8月16日-17日在国家速滑馆（冰丝带）举办其他竞技类、表演类和场景类比赛。
	</p>
	<p class="p" style="text-indent:24pt;">
		&nbsp;
	</p>
	<p class="p" style="text-indent:28pt;">
		(更多赛事信息敬请关注后续官网和微信公众号的更新）
	</p>
`,
            fileInfo: [
                {
                    label: '官方文件',
                    title: '2025世界人形机器人运动会比赛规则',
                    time: '2025-05-07',
                    content: `<p class="p" style="text-indent:28pt;">
	<span>欢迎来到</span><span>2025世界人形机器人运动会！这是一场汇聚全球顶尖科技、工程艺术与运动精神的巅峰盛会，通过搭建竞技展示平台，进行赛事挑战与真实场景测试，推动人形机器人在运动能力、协作智能与场景化服务中的跨越式发展，更快更好地走进人类生活。</span>
</p>
<p class="p" style="text-indent:28pt;">
	<span>在竞技赛中，人形机器人运动员将在田径、足球、自由体操等传统体育项目中展现力量、速度与柔韧性的完美平衡；表演赛中</span><span>,单机与群体舞蹈将以动态美学和算法创造力呈现科技与艺术的交响；场景赛则聚焦工厂、医院、酒店等实际场景，检验机器人在复杂环境中的功能性与适应性。</span>
</p>
<p class="p" style="text-indent:28pt;">
	<span>作为全球首个涵盖</span><span>"体育+艺术+应用"的全维度人形机器人赛事，我们秉持公平竞争、开放创新、安全可控、产业联动的原则,鼓励参赛团队以创新技术突破运动极限，以跨学科协作探索人机共生的无限可能。</span>
</p>
<p class="p" style="text-indent:28pt;">
	(注：第一批比赛规则已在官网开放下载，动态优化中。5月20日前，欢迎参赛团队就赛事优化提出合理建议，可通过官方邮箱
</p>
<p class="p" style="text-indent:28pt;">
	<span style="color:#337FE5;">2025whrg@whrgoc.com</span>&nbsp;进行反馈。
</p>`
                }],
            partnerInfo: {
                title: `<p class="p">
	<strong>一、赞助等级</strong>
</p>`,
content: `<p class="p">
	<strong>第一层级：合作伙伴</strong>
</p>
<p class="p">
	全球合作伙伴
</p>
<p class="p">
	战略合作伙伴
</p>
<p class="p">
	官方合作伙伴
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	<strong>第二层级：赞助商</strong>
</p>
<p class="p">
	官方赞助商
</p>
<p class="p">
	&nbsp;
</p>
<p class="p">
	<strong>第三层级：供应商</strong>
</p>
<p class="p">
	供应商
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; 具体价位将在征集过程中向潜在赞助企业作出说明。企业赞助需以现金为主。世界人形机器人运动会组委会根据需要，可接受赞助企业提供的物资、技术和服务，这部分物资、技术和服务可作为现金等价物，计入赞助企业的赞助金额中。
</p>
<p class="p">
	二、权益回报
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; 不同赞助层级的赞助企业将享有不同的权益回报。组委会给予赞助企业的主要回报方式包括：
</p>
<p class="p">
	1、专有权益
</p>
<p class="p">
	(1）组合称谓权：企业可在产品包装、产品宣传、电视广告及其它活动中使用组合称谓。
</p>
<p class="p">
	(2）影像资料使用权：企业可在商务和公益活动中享有使用"2025世界人形机器人运动会"相关影像资料权益。
</p>
<p class="p">
	(3）竞品排他权：所有权益按赞助商级别享受相应竞品排他权。
</p>
<p class="p">
	2、场地展示
</p>
<p class="p">
	(1）矩阵展示
</p>
<p class="p">
	(2）场馆宣传大屏展示
</p>
<p class="p">
	(3）颁奖及媒体综合区背板
</p>
<p class="p">
	(4）场馆周边及场地道旗
</p>
<p class="p">
	(5）观众席围挡展示
</p>
<p class="p">
	(6）看台区域、环廊区域展示
</p>
<p class="p">
	(7）场馆内专属区域展示
</p>
<p class="p">
	(8）场馆内专属休息室或接待区
</p>
<p class="p">
	(9）嘉年华专属展示区及品牌推广
</p>
<p class="p">
	3、印刷品展示
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; 赛事秩序册展示、赛事证件展示、所有官方人员赛事证书相关logo矩阵展示。
</p>
<p class="p">
	4、贵宾礼遇
</p>
<p class="p">
	&nbsp; &nbsp; &nbsp; 企业VIP住宿接待、赛间主持口播、赛事观赛名额等。
</p>
<p class="p">
	5、公关和品牌传播
</p>
<p class="p">
	权威媒体采访及品牌露出。
</p>
<p class="p">
	(以上权益回报最终以签署的赞助协议为准。）
</p>
<p class="p">
	<span>邮箱：</span>marketing@whrgoc.com
</p>`
         },
         contactInfo: `<p class="p">
	<span>对本届赛事有任何好的意见和建议，欢迎通过官方邮箱</span> <span style="color:#337FE5;">2025whrg@whrgoc.com</span>&nbsp;进行反馈，期待大家的共同参与。
</p>`
        }
    },
    methods: {
        init() {
            this.active = localStorage.getItem('activeTabs') || 'Announcement'
        },
        onClick(name, title) {
            localStorage.setItem('activeTabs', this.active)
        },
        updateCountdown() {
            const now = new Date().getTime() // 当前时间的时间戳
            const distance = this.endDate - now // 计算距离目标日期的毫秒数
            // 时间计算
            this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
            this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
        }
    },
    computed: {
        dayNum () {
        if (this.days < 10) return '0' + this.days
        return this.days
        },
        hourNum () {
            if (this.hours < 10) return '0' + this.hours
            return this.hours
        },
        minuteNum () {
            if (this.minutes < 10) return '0' + this.minutes
            return this.minutes
        },
        secondNum () {
            if (this.seconds < 10) return '0' + this.seconds
            return this.seconds
        }
    },
    watch: {},
    filters: {},
    components: { itemList },
    beforeDestroy() {
        clearInterval(this.timer) // 组件销毁前清除定时器
    }
}
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100vh;
    overflow: auto;
    background: #F5F6F8;
    .header {
        position: relative;
        width: 100%;
        height: 307px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #333333;
        background-color: #fff;
        z-index: 99;
        .bg-img{
            width: 100%;
        }
        .time{
            position: absolute;
            bottom: 0px;
            width: calc(100% - 52px);
            background: rgba($color: #000000, $alpha: .5);
            height: 100px;
            border-radius: 15px 15px 0 0;
            display: flex;
            justify-content: start;
            align-items: center;
            flex-direction: column;
            padding: 11px;
            .title{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                margin-bottom: 5px;
            }
            .content{
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 28px;
                text-align: left;
                font-style: normal;
                span{
                    font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                }
            }
        }
    }
    .content-box{
        width: 100%;
        background: #F5F6F8 ;
        min-height: calc(100vh - 307px);
        border-radius: 10px 10px 0 0;
        position: relative;
        top: -30px;
        z-index: 110;
        // padding-top: 10px;
        .card-box{
            padding: 0 16px 16px 16px;
            max-height: calc(100vh - 387px);
            overflow: scroll;
             .card-box{
                width: 100%;
                background: #FFFFFF;
                box-shadow: 0px 2px 8px 0px rgba(222,229,243,0.3);
                padding: 12px 20px;
                border-radius: 6px;
                margin-bottom: 10px;
                .content{
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #333333;
                  line-height: 20px;
                  text-align: left;
                  font-style: normal;
                  padding-top: 8px;
                }
            }
        }
    }
}
</style>
<style>
.van-tabs__line{
  bottom: 0.6rem;
}

.van-tabs__wrap.van-tabs__wrap--scrollable{
  border-radius:10px 10px 0 0;
}
</style>
